import { render, staticRenderFns } from "./WithExtra.vue?vue&type=template&id=76ba28a8&scoped=true&"
import script from "./WithExtra.vue?vue&type=script&lang=js&"
export * from "./WithExtra.vue?vue&type=script&lang=js&"
import style0 from "./WithExtra.vue?vue&type=style&index=0&id=76ba28a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ba28a8",
  null
  
)

export default component.exports